import React, { Component } from 'react'
import { Button, Table, TableBody, TableCell, TableHead, TableRow, IconButton } from "@mui/material";
import { Container, Form } from 'react-bootstrap';
import { getISOWeek, formatDate, formatWeek, getWeekNumber, getWeekDetails, deviceLabel, transactionStatus, sumMoney, displayStoredDate, partyLabel, formatAmount } from '../../../helper';
import Select from '../../../Components/PCSelect';
import WeekRangeSelect from '../../../Components/WeekRangeSelect';
import axios from "axios";
import Swal from "sweetalert2";
import RemoveIcon from '@mui/icons-material/Delete';
import PrintIcon from '@mui/icons-material/Print';
import ReactToPrint from 'react-to-print';
import SaleDeviceAF from '../../../Report/SaleDevice/SaleDeviceAF';
import PhoneClinicGrid from '../../../Components/PhoneClinicGrid';
import RowActions from '../../../Components/PhoneClinicGrid/RowActions';
import { CARD, COL_HEAD, INPUT, LABEL, SELECT_STYLES, ToggleSwitch } from '../shared/txStyles';
import StatusChip from '../shared/StatusChip';

import AmountInput from '../../../Components/AmountInput';
import PageHeader from '../shared/PageHeader';
export default class WarehouseDeviceSale extends Component {
    constructor(props) {
        super(props);
        this.state = {
            addSale: false,
            SaleList: [],
            ItemList: [],

            WareHouseList: [{
                value: "F4",
                label: "F4"
            }],


            Customer: "",
            SALE_TO_TYPE: "Customer",
            Warehouse: {
                value: "F4",
                label: "F4"
            },
            SALE_DATE: formatDate(new Date().toDateString()),

            Item: {
                ItemName: "",
                ItemIMEI: "",
                ItemDesc: "",
                ItemRate: 0,
                ItemQuantity: 0,
                ItemDisc: 0,
                ItemAmount: 0,
                ItemDisType: "number"
            },

            AddedItemList: [],
            PC_WHS_INV: "",
            PC_WHS_ID: "",
            InventoryList: [],
            EMAIL_TO: "",
            isEdit: false,
            ShopList: [],
            SaleToShop: "",
            SaleToWarehouse: "",

            // new
            SALE_WEEK: formatWeek(),
            shopPaymentDays: [],
            RevokeItems: [],

            rateEditable: -1,
            quantityEditable: -1,
            editObj: {
                idx: "",
                label: "",
                value: ""
            }
        };
        this.gridRef = React.createRef(null);
    }


    // componentDidMount() {
    //     this.getWHSale()
    // }

    async getShopList() {
        const getShops = await axios.get(`${process.env.REACT_APP_BASE_URL}services/query/PCGetShops.php`);
        let shopData = getShops.data
        let ShopList = []
        if (shopData.success === 1) {
            for (let i = 0; i < shopData.data.length; i++) {
                const shop = shopData.data[i];
                ShopList.push({
                    value: shop.PC_SP_ID,
                    label: shop.SP_NAME
                })
            }
        }
        this.setState({ ShopList })
    }

    async getInventory() {
        let formData = {
            WH_ID: localStorage.getItem('PC_GRP_ATT')
        };
        const getAllInventory = await axios.post(`${process.env.REACT_APP_BASE_URL}services/query/getWarehouseInventory.php`, formData);
        let serviceData = getAllInventory.data

        let ItemList = []
        let InventoryList = []
        if (serviceData.success === 1) {
            InventoryList = serviceData.data
            for (let i = 0; i < InventoryList.length; i++) {
                const element = InventoryList[i];
                ItemList.push({
                    'ItemBrand': element.ItemBrand,
                    'ItemType': element.ItemType,
                    'display': element.ItemName,
                    'label': `${element.ItemName} (${element.ItemIMEI}) ${element.ItemDesc}`,
                    'value': element.ItemIMEI,
                    'id': element.ItemIMEI
                })
            }

        }
        this.setState({ InventoryList, ItemList })

    }

    async hanldeAddSale() {
        let weekDetails = getWeekDetails();
        let shopPaymentDays = []
        if (weekDetails.dates.length > 0) {
            for (let i = 0; i < weekDetails.dates.length; i++) {
                const WeekPerDay = weekDetails.dates[i];
                shopPaymentDays.push({
                    'DateAndDay': WeekPerDay
                })
            }
        }
        this.getShopList()
        this.getInventory()
        this.setState({
            shopPaymentDays,
            SALE_WEEK: weekDetails.weekId,
            SALE_DATE: formatDate(new Date().toDateString()),
            addSale: true,
            isEdit: false
        })
    }

    async databyID(id) {
        let formData = {
            PC_WH_ID: localStorage.getItem('PC_GRP_ATT'),
            PC_WHS_ID: id
        };
        const getAllInventory = await axios.post(`${process.env.REACT_APP_BASE_URL}services/query/WarehouseModule/getWarehouseDeviceSale.php`, formData);
        return getAllInventory

    }

    async handleUpdateSale(id) {
        let getdatabyID = await this.databyID(id)
        if (getdatabyID.data && getdatabyID.data.success === 1) {
            const SaleData = getdatabyID.data.data[0]
            let shpValue = {}
            if (SaleData.PC_WHS_TOTYPE === "Shop") {
                shpValue = {
                    value: SaleData.PC_WHS_CUSTOMER,
                    label: SaleData.SALE_TO
                }
            }
            this.getInventory()
            this.setState({
                isEdit: true,
                addSale: true,
                PC_WHS_ID: SaleData.PC_WHS_ID,
                PC_WHS_WHID: SaleData.PC_WHS_WHID,
                SALE_WEEK: SaleData.PC_WHS_WEEK,
                Customer: SaleData.PC_WHS_CUSTOMER,
                SaleToShop: shpValue,
                SALE_TO_TYPE: SaleData.PC_WHS_TOTYPE,
                PC_WHS_INV: SaleData.PC_WHS_INV,
                SALE_DATE: SaleData.PC_WHS_DATE,
                AddedItemList: JSON.parse(SaleData.PC_WHS_ITEM),
                shopPaymentDays: JSON.parse(SaleData.PC_WHS_DAYS),
            })
        }
    }

    handleChangeUpdatedItem(fieldName, evt, evtA) {
        let { Item, InventoryList } = this.state;
        Item['ItemQuantity'] = 1
        Item['ItemDisc'] = 0
        switch (fieldName) {
            case 'ItemName':
                let findInventory = InventoryList.filter(x => x.ItemIMEI === evt.value)?.[0]
                Item['ItemName'] = evt
                Item['ItemRate'] = parseInt(findInventory.ItemSellRate)
                Item['ItemAmount'] = parseInt(findInventory.ItemSellRate)
                Item['ItemIMEI'] = findInventory.ItemIMEI
                Item['ItemDesc'] = findInventory.ItemDesc
                break;

            case 'ItemDisType':
                Item['ItemDisType'] = evtA
                if (evtA === 'number') {
                    Item['ItemAmount'] = (Item['ItemQuantity'] * Item['ItemRate']) - Item['ItemDisc']
                } else {
                    Item['ItemAmount'] = (Item['ItemQuantity'] * Item['ItemRate']) - ((Item['ItemQuantity'] * Item['ItemRate']) * (Item['ItemDisc'] / 100))
                }
                break;
            case 'ItemQuantity':
                Item[evt.target.name] = evt.target.value
                // now setting relative condition
                if (Item['ItemDisType'] === 'number') {
                    Item['ItemAmount'] = (evt.target.value * Item['ItemRate']) - Item['ItemDisc']
                } else {
                    Item['ItemAmount'] = (evt.target.value * Item['ItemRate']) - ((evt.target.value * Item['ItemRate']) * (Item['ItemDisc'] / 100))
                }
                break;
            case 'ItemRate':
                Item[evt.target.name] = evt.target.value
                // now setting relative condition
                if (Item['ItemDisType'] === 'number') {
                    Item['ItemAmount'] = (Item['ItemQuantity'] * evt.target.value) - Item['ItemDisc']
                } else {
                    Item['ItemAmount'] = (Item['ItemQuantity'] * evt.target.value) - ((Item['ItemQuantity'] * evt.target.value) * (Item['ItemDisc'] / 100))
                }
                break;

            case 'ItemDisc':
                Item[evt.target.name] = evt.target.value
                // now setting relative condition
                if (Item['ItemDisType'] === 'number') {
                    Item['ItemAmount'] = (Item['ItemQuantity'] * Item['ItemRate']) - evt.target.value
                } else {
                    Item['ItemAmount'] = (Item['ItemQuantity'] * Item['ItemRate']) - ((Item['ItemQuantity'] * Item['ItemRate']) * (evt.target.value / 100))
                }
                break;

            case 'ItemIMEI':
                // let findInventory = InventoryList.filter(x => x.PC_ITEM_BARCODE === evt.target.value || x.PC_ITEM_BARCODE === evt.target.value)?.[0]
                Item[evt.target.name] = evt.target.value
                break;

            default:
                Item[evt.target.name] = evt.target.value
                break;

        }
        this.setState({ Item })
    }


    handleValidateItem(Item, AddedItemList, ItemList) {
        if (Item.ItemName === '' || Item?.ItemName?.value === "") {
            Swal.fire(
                'Error',
                'Please select Item',
                'error'
            )
            return false
        }
        if (Item.ItemRate === '' || parseInt(Item.ItemRate) <= 0) {
            Swal.fire(
                'Error',
                'Rate must be greater than 0',
                'error'
            )
            return false
        }
        if (Item.ItemQuantity === '' || parseInt(Item.ItemQuantity) <= 0) {
            Swal.fire(
                'Error',
                'Quantity must be greater than 0',
                'error'
            )
            return false
        }

        for (let i = 0; i < AddedItemList.length; i++) {
            const ItemList = AddedItemList[i];
            if (ItemList.ItemIMEI === Item.ItemIMEI) {
                let RefreshItem = {
                    ItemName: "",
                    ItemIMEI: "",
                    ItemDesc: "",
                    ItemRate: 0,
                    ItemQuantity: 0,
                    ItemDisc: 0,
                    ItemAmount: 0,
                    ItemDisType: "number"
                }
                this.setState({ Item: RefreshItem })
                Swal.fire(
                    'Error',
                    'Device already exists on sale list',
                    'error'
                )
                return false
            }
        }

        let a = ItemList.filter(x => x.id === Item.ItemIMEI)
        if (a.length === 0) {
            let RefreshItem = {
                ItemName: "",
                ItemIMEI: "",
                ItemDesc: "",
                ItemRate: 0,
                ItemQuantity: 0,
                ItemDisc: 0,
                ItemAmount: 0,
                ItemDisType: "number"
            }
            this.setState({ Item: RefreshItem })
            Swal.fire(
                'Error',
                'No device found on inventory',
                'error'
            )
            return false
        }

        return true
    }

    handleAddItem() {
        let { Item, AddedItemList, ItemList } = this.state
        if (!this.handleValidateItem(Item, AddedItemList, ItemList)) return
        let UpdateItemList = [Item].concat(AddedItemList)
        this.setState({ AddedItemList: UpdateItemList })
        let RefreshItem = {
            ItemName: "",
            ItemIMEI: "",
            ItemDesc: "",
            ItemRate: 0,
            ItemQuantity: 0,
            ItemDisc: 0,
            ItemAmount: 0,
            ItemDisType: "number"
        }
        this.setState({ Item: RefreshItem })

    }

    async handleChange(fieldName, evt) {
        let value
        switch (fieldName) {
            case 'SALE_WEEK':
                value = evt.target.value
                let WeekNumber = evt.target.value;
                let weekYearArr = WeekNumber.split("-");
                weekYearArr[1] = weekYearArr[1].replace("W", "");
                let MappedValue = weekYearArr.map(n => parseInt(n)).reverse();
                let WeekOut = await getISOWeek(...MappedValue)
                let shopPaymentDays = [];
                let SALE_DATE = "";
                if (WeekOut.length > 0) {
                    SALE_DATE = formatDate(WeekOut[0]);
                    for (let i = 0; i < WeekOut.length; i++) {
                        const WeekPerDay = WeekOut[i];
                        shopPaymentDays.push({
                            'DateAndDay': WeekPerDay
                        })
                    }
                }
                this.setState({ shopPaymentDays, SALE_DATE })

                break;
            case 'Warehouse':
                value = evt
                break;
            case 'SaleToShop':
            case 'SaleToWarehouse':
                // fieldName = "Customer"
                value = evt
                break;
            case 'SALE_DATE':
                value = evt.target.value
                let validate = getWeekDetails(value)
                let { SALE_WEEK } = this.state;
                if (validate.weekId !== SALE_WEEK) {
                    value = "";
                    return
                }
                break;
            default:
                value = evt.target.value
                break;
        }
        this.setState({
            [fieldName]: value
        })
    }

    ValidateInvoice() {
        let { SALE_TO_TYPE } = this.state;

        if (SALE_TO_TYPE === "Customer" && this.state.Customer === "") {
            this.props.toggleLoader(false)
            Swal.fire(
                'Error',
                'Please Enter Customer',
                'error'
            )
            return false
        }

        if (SALE_TO_TYPE === "Shop" && this.state.SaleToShop === "") {
            this.props.toggleLoader(false)
            Swal.fire(
                'Error',
                'Please select Shop',
                'error'
            )
            return false
        }

        if (this.state.AddedItemList.length === 0) {
            this.props.toggleLoader(false)
            Swal.fire(
                'Error',
                'Please Add atleast 1 Item',
                'error'
            )
            return false
        }
        return true
    }

    async handleSaveInvoice() {
        this.props.toggleLoader(true)
        if (!this.ValidateInvoice()) return
        let { SALE_TO_TYPE } = this.state
        let formData = {
            PC_WHS_ID: this.state.PC_WHS_ID,
            PC_WHS_WHID: localStorage.getItem('PC_GRP_ATT'),
            PC_WHS_DAYS: JSON.stringify(this.state.shopPaymentDays),
            PC_WHS_WEEK: this.state.SALE_WEEK,
            PC_WHS_CUSTOMER: SALE_TO_TYPE === 'Customer' ? this.state.Customer : this.state.SaleToShop?.value,
            PC_WHS_TOTYPE: SALE_TO_TYPE,
            PC_WHS_LABEL: SALE_TO_TYPE === 'Customer' ? this.state.Customer : this.state.SaleToShop?.label,
            PC_WHS_DATE: this.state.SALE_DATE,
            PC_WHS_ITEM: JSON.stringify(this.state.AddedItemList),
            PC_WHS_NETAMT: this.renderTotalAmount(),
            PC_WHS_INV: this.state.PC_WHS_INV,
            RevokeItems: JSON.stringify(this.state.RevokeItems)
        }

        let mVarFolder = 'PCAddWarehouseSale';
        if (this.state.isEdit) { mVarFolder = 'PCEditWarehouseSale'; }
        try {
            let getSaleInvoiceResult = await axios.post(`${process.env.REACT_APP_BASE_URL}services/mutation/SaleNPurchase/${mVarFolder}.php`, formData);
            this.props.toggleLoader(false)
            if (getSaleInvoiceResult.data.status === 200) {
                Swal.fire(
                    'Success',
                    getSaleInvoiceResult.data.message,
                    'success'
                )
            } else {
                Swal.fire(
                    'Error',
                    getSaleInvoiceResult.data.message,
                    'error'
                )
            }
            this.handleExit()
        } catch (error) {
            this.props.toggleLoader(false)
            console.error('error :>> ', error);
        }
    }

    handleValidate() {
        if (this.state.EMAIL_TO === "") {
            Swal.fire(
                'Error',
                'Please Enter Email Address',
                'error'
            )
            return false
        }
        return true
    }

    async handleSendEmail() {

        if (!this.handleValidate()) return

        let formData = {
            SALE_BY: localStorage.getItem('PC_USR_NAME'),
            SALE_FROM: localStorage.getItem('PC_GRP_ATT'),
            SALE_CUSTOMER: this.state.Customer,
            SALE_WAREHOUSE: this.state.Warehouse.value,
            SALE_DATE: this.state.SALE_DATE,
            SALE_ITEM: JSON.stringify(this.state.AddedItemList),
            EMAIL_TO: this.state.EMAIL_TO
        }
        let getSaleInvoiceResult = await axios.post(`${process.env.REACT_APP_BASE_URL}mail/SendMail.php`, formData);
        if (getSaleInvoiceResult.data.status === 201) {
            Swal.fire(
                'Success',
                'Email has been send!!',
                'success'
            )
        }
    }

    handleExit() {
        this.setState({
            addSale: false,
            ItemList: [],

            WareHouseList: [{
                value: "F4",
                label: "F4"
            }],

            Customer: "",
            EMAIL_TO: "",
            Warehouse: {},
            PC_WHS_ID: "",
            SALE_DATE: formatDate(new Date().toDateString()),

            Item: {
                ItemName: "",
                ItemIMEI: "",
                ItemDesc: "",
                ItemRate: 0,
                ItemQuantity: 0,
                ItemDisc: 0,
                ItemAmount: 0,
                ItemDisType: "number"
            },

            AddedItemList: [],
            isEdit: false,
            SALE_WEEK: formatWeek(),
            RevokeItems: []
        })
        this.getWHSale()
    }

    renderTotalAmount() {
        let { AddedItemList } = this.state;
        let Price = sumMoney(AddedItemList, "ItemAmount");
        return parseFloat(Price).toFixed(2)
    }

    handleKeyPress(evnt) {
        if (evnt.key === 'Enter') {
            this.handleAddItem()
        }
    }

    handleEnterImei(evnt) {
        if (evnt.key === 'Enter') {
            let { Item, InventoryList } = this.state;
            let FilterItem = InventoryList.filter(x => x.ItemIMEI === Item.ItemIMEI)
            if (FilterItem.length > 0) {
                Item['ItemName'] = {
                    'display': FilterItem[0].ItemName,
                    'label': `${FilterItem[0].ItemName} (${FilterItem[0].ItemIMEI})`,
                    'value': FilterItem[0].ItemIMEI,
                    'id': FilterItem[0].ItemIMEI,
                    'ItemBrand': FilterItem[0].ItemBrand,
                    'ItemType': FilterItem[0].ItemType
                }
                Item['ItemDesc'] = FilterItem[0].ItemDesc
                Item['ItemRate'] = FilterItem[0].ItemSellRate
                Item['ItemQuantity'] = 1
                Item['ItemDisc'] = 0
                Item['ItemAmount'] = (1 * FilterItem[0].ItemSellRate) - ((1 * FilterItem[0].ItemSellRate) * (0 / 100))
            }
            this.setState({ Item }, () => { this.handleAddItem() })
        }
    }

    // async handleUndoTrans(evt) {
    //     evt.preventDefault();
    //     let { SALE_TO_TYPE } = this.state;
    //     let formData = {
    //         PC_WHS_ID: this.state.PC_WHS_ID,
    //         PC_WHS_WHID: 1,
    //         PC_WHS_INV: this.state.PC_WHS_INV,
    //         PC_WHS_CUSTOMER: SALE_TO_TYPE === 'Customer' ? this.state.Customer : this.state.SaleToShop?.value,
    //         PC_WHS_TOTYPE: SALE_TO_TYPE,
    //         PC_WHS_ITEM: JSON.stringify(this.state.AddedItemList),
    //     }
    //     let getSaleInvoiceResult = await axios.post(`${process.env.REACT_APP_BASE_URL}services/mutation/SaleNPurchase/UndoWHTrans.php`, formData);
    //     if (getSaleInvoiceResult.data.status === 200) {
    //         Swal.fire(
    //             'Success',
    //             getSaleInvoiceResult.data.message,
    //             'success'
    //         )
    //     } else {
    //         Swal.fire(
    //             'Error',
    //             getSaleInvoiceResult.data.message,
    //             'error'
    //         )
    //     }
    //     this.handleExit()

    // }

    handleRemove(index, itemObj) {
        if (this.state.isEdit) {
            let { ItemList, InventoryList, RevokeItems } = this.state;
            InventoryList.push({
                'ItemName': itemObj.ItemName.display,
                'ItemIMEI': itemObj.ItemIMEI,
                'ItemBrand': itemObj.ItemName.ItemBrand,
                'ItemType': itemObj.ItemName.ItemType,
                'ItemDesc': itemObj.ItemDesc,
                'ItemSellRate': itemObj.ItemAmount
            })

            RevokeItems.push(itemObj.ItemName)
            ItemList.push(itemObj.ItemName)
            this.setState({ InventoryList, ItemList, RevokeItems })
        }
        let { AddedItemList } = this.state;
        AddedItemList.splice(index, 1)
        this.setState({ AddedItemList })
    }


    handleValidateUpdateItem(Item) {
        if (Item.label === "ItemRate" && (Item.value === '' || parseFloat(Item.value).toFixed(2) <= 0.00)) {
            Swal.fire(
                'Error',
                'Rate must be greater than 0',
                'error'
            )
            return false
        }
        if (Item.label === "ItemQuantity" && (Item.value === '' || parseInt(Item.value) <= 0)) {
            Swal.fire(
                'Error',
                'Quantity must be greater than 0',
                'error'
            )
            return false
        }
        return true
    }

    handleEditItems(index, fieldName, currntValue, evt) {
        evt.preventDefault();
        let editObj = {
            idx: index,
            label: fieldName,
            value: currntValue
        }
        let otherName = fieldName === "ItemRate" ? "quantityEditable" : "rateEditable"
        let stateName = fieldName === "ItemRate" ? "rateEditable" : "quantityEditable"
        this.setState({ [stateName]: index, [otherName]: -1, editObj })
    }

    handleChangeEditableItem(evt) {
        let { editObj } = this.state;
        editObj[evt.target.name] = evt.target.value
        this.setState({ editObj })
    }

    handleUpdateEditableItem(applyChange, evnt) {
        let { editObj, AddedItemList } = this.state;
        switch (applyChange) {
            case "key_press":
                if (evnt.key === 'Enter') {
                    if (!this.handleValidateUpdateItem(editObj)) return;
                    AddedItemList[editObj.idx][editObj.label] = editObj.value;
                    let otherObj = editObj.label === "ItemRate" ? "ItemQuantity" : "ItemRate";
                    if (AddedItemList[editObj.idx]['ItemDisType'] === 'number') {
                        AddedItemList[editObj.idx]['ItemAmount'] = parseFloat((AddedItemList[editObj.idx][otherObj] * editObj.value) - AddedItemList[editObj.idx]['ItemDisc']).toFixed(2)
                    } else {
                        AddedItemList[editObj.idx]['ItemAmount'] = parseFloat((AddedItemList[editObj.idx][otherObj] * editObj.value) - ((AddedItemList[editObj.idx][otherObj] * editObj.value) * (AddedItemList[editObj.idx]['ItemDisc'] / 100))).toFixed(2)
                    }
                    let stateName = editObj.label === "ItemRate" ? "rateEditable" : "quantityEditable"
                    this.setState({ [stateName]: -1, AddedItemList })
                }
                break;

            default:
                if (!this.handleValidateUpdateItem(editObj)) return;
                AddedItemList[editObj.idx][editObj.label] = editObj.value;
                let otherObj = editObj.label === "ItemRate" ? "ItemQuantity" : "ItemRate";
                if (AddedItemList[editObj.idx]['ItemDisType'] === 'number') {
                    AddedItemList[editObj.idx]['ItemAmount'] = parseFloat((AddedItemList[editObj.idx][otherObj] * editObj.value) - AddedItemList[editObj.idx]['ItemDisc']).toFixed(2)
                } else {
                    AddedItemList[editObj.idx]['ItemAmount'] = parseFloat((AddedItemList[editObj.idx][otherObj] * editObj.value) - ((AddedItemList[editObj.idx][otherObj] * editObj.value) * (AddedItemList[editObj.idx]['ItemDisc'] / 100))).toFixed(2)
                }
                let stateName = editObj.label === "ItemRate" ? "rateEditable" : "quantityEditable"
                this.setState({ [stateName]: -1, AddedItemList })
                break;
        }
    }

    async handleDeleteRecord(PC_WHS_ID) {
        Swal.fire({
            title: 'Do you want to delete sale record ?',
            icon: "question",
            showCancelButton: true,
            confirmButtonText: 'Yes',
            cancelButtonText: 'No'
        }).then(async (result) => {
            if (result.isConfirmed) {
                this.props.toggleLoader(true)
                let formData = {
                    PC_WHS_ID: PC_WHS_ID,
                    PC_WHS_WHID: localStorage.getItem('PC_GRP_ATT'),
                }
                console.log('formData', formData)
                try {
                    let getSaleInvoiceResult = await axios.post(`${process.env.REACT_APP_BASE_URL}services/delete/sale/DeleteWhDevice.php`, formData);
                    this.props.toggleLoader(false)
                    if (getSaleInvoiceResult.data.status === 200) {
                        Swal.fire(
                            'Success',
                            getSaleInvoiceResult.data.message,
                            'success'
                        )
                        this.getWHSale()
                    } else {
                        Swal.fire(
                            'Error',
                            getSaleInvoiceResult.data.message,
                            'error'
                        )
                    }
                } catch (error) {
                    this.props.toggleLoader(false)
                }
            }
        })
    }

    async getWHSale(searchData = [], pagination = { recordOffset: 1, pageSize: 50 }) {
        this.props.toggleLoader(true)
        let formData = {
            PC_WH_ID: localStorage.getItem('PC_GRP_ATT'),
            searchData,
            pageSize: pagination.pageSize,
            recordOffset: pagination.recordOffset,
        };
        const getAllSale = await axios.post(`${process.env.REACT_APP_BASE_URL}services/query/SaleNPurchase/PCGetGridWarehouseSale.php`, formData);
        let SaleData = getAllSale.data
        let SaleList = []
        if (SaleData.success === 1) {
            SaleList = SaleData.data
            pagination.totalItems = parseInt(SaleData.Page_count[0]['TOTAL_PAGE_COUNT'])
            pagination.totalPages = Math.ceil(pagination.totalItems / pagination.pageSize || 50)
            this.gridRef.current?.setPaginationData(pagination)
        }
        this.setState({ SaleList })
        this.props.toggleLoader(false)
    }



    render() {
        const { addSale } = this.state;
        let { Item, shopPaymentDays } = this.state;
        const weekLabel = shopPaymentDays.length > 0
            ? shopPaymentDays[0]['DateAndDay'] + ' - ' + shopPaymentDays[6]['DateAndDay']
            : '';

        if (!addSale) {
            return (
                <Container fluid style={{ padding: '24px' }}>
                    <PhoneClinicGrid
                        ref={this.gridRef}
                        title="DEVICE SALE"
                        buttonLabel="Add sale"
                        onClickButton={this.hanldeAddSale.bind(this)}
                        getData={this.getWHSale.bind(this)}
                        isEditable={true}
                        tableHeadData={[
                            { label: "DATE", isHidden: false },
                            { label: "SALE TO", isHidden: false },
                            { label: "DEVICE", isHidden: false },
                            { label: "STATUS", isHidden: false },
                            { label: "TOTAL PRICE", isHidden: false, align: 'right' },
                        ]}
                    >
                        {/* One row per record (flattened 2026-10-22). Columns follow the shared sale/purchase standard:
                            DATE | SALE TO or PURCHASE FROM as "Name (Type)" | DEVICE (device screens) | STATUS | TOTAL PRICE. */}
                        {this.state.SaleList.map((row, idx) => (
                            <TableRow key={idx}>
                                <TableCell>{displayStoredDate(row.PC_WHS_DATE)}</TableCell>
                                <TableCell>{partyLabel(row.SALE_TO, row.PC_WHS_TOTYPE)}</TableCell>
                                <TableCell>{deviceLabel(row.PC_WHS_ITEM)}</TableCell>
                                <TableCell><StatusChip label={transactionStatus(row, 'sale')} /></TableCell>
                                <TableCell align="right"><strong>£ {formatAmount(row.PC_WHS_NETAMT)}</strong></TableCell>
                                <TableCell align='center'>
                                    <RowActions actions={[
                                        { type: 'edit', onClick: this.handleUpdateSale.bind(this, row.PC_WHS_ID) },
                                        { type: 'delete', onClick: this.handleDeleteRecord.bind(this, row.PC_WHS_ID) },
                                    ]} />
                                </TableCell>
                            </TableRow>
                        ))}
                    </PhoneClinicGrid>
                </Container>
            );
        }

        return (
            <Container fluid style={{ padding: '24px', background: '#f8f9ff', minHeight: '100vh' }}>
                {/* Header */}
                <PageHeader title="Sale By Warehouse" subtitle={weekLabel} right={<><ToggleSwitch options={['Customer', 'Shop']} value={this.state.SALE_TO_TYPE} onChange={(v) => this.setState({ SALE_TO_TYPE: v })} /></>} style={{ margin: "0 0 16px" }} />

                {/* Input Card */}
                <div style={{ ...CARD, padding: 20, marginBottom: 16 }}>
                    <div className="pc-form-grid" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 16, marginBottom: 16 }}>
                        <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
                            <div>
                                <label style={LABEL}>WEEK</label>
                                <WeekRangeSelect menuPortalTarget={document.body} menuPlacement="auto" value={this.state.SALE_WEEK} onChange={this.handleChange.bind(this, 'SALE_WEEK')} />
                            </div>
                            <div>
                                <label style={LABEL}>ITEM</label>
                                <Select menuPortalTarget={document.body} name="ItemName" menuPlacement="auto" styles={SELECT_STYLES} value={Item['ItemName']} options={this.state.ItemList} onChange={this.handleChangeUpdatedItem.bind(this, 'ItemName')} />
                            </div>
                        </div>
                        <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
                            <div>
                                <label style={LABEL}>{this.state.SALE_TO_TYPE}</label>
                                {this.state.SALE_TO_TYPE === 'Customer'
                                    ? <Form.Control style={INPUT} value={this.state.Customer} onChange={this.handleChange.bind(this, 'Customer')} />
                                    : <Select menuPortalTarget={document.body} menuPlacement="auto" styles={SELECT_STYLES} value={this.state.SaleToShop} options={this.state.ShopList} onChange={this.handleChange.bind(this, 'SaleToShop')} />
                                }
                            </div>
                            <div className="pc-form-grid" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
                                <div>
                                    <label style={LABEL}>RATE</label>
                                    <AmountInput name="ItemRate" style={INPUT} value={Item['ItemRate']} onKeyPress={this.handleKeyPress.bind(this)} onChange={this.handleChangeUpdatedItem.bind(this, 'ItemRate')} />
                                </div>
                                <div>
                                    <label style={LABEL}>DISCOUNT</label>
                                    <AmountInput name="ItemDisc" style={INPUT} value={Item['ItemDisc']} onKeyPress={this.handleKeyPress.bind(this)} onChange={this.handleChangeUpdatedItem.bind(this, 'ItemDisc')} />
                                </div>
                            </div>
                        </div>
                        <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
                            <div>
                                <label style={LABEL}>DATE</label>
                                <Form.Control type="date" name="SALE_DATE" style={INPUT}
                                    min={shopPaymentDays.length > 0 ? formatDate(shopPaymentDays[0]['DateAndDay']) : ''}
                                    max={shopPaymentDays.length > 0 ? formatDate(shopPaymentDays[6]['DateAndDay']) : ''}
                                    value={this.state.SALE_DATE} onChange={this.handleChange.bind(this, 'SALE_DATE')} />
                            </div>
                            <div className="pc-form-grid" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12, alignItems: 'end' }}>
                                <div>
                                    <label style={LABEL}>TYPE</label>
                                    <ToggleSwitch options={['£', '%']} value={Item['ItemDisType'] === 'number' ? '£' : '%'} onChange={(v) => this.handleChangeUpdatedItem('ItemDisType', null, v === '£' ? 'number' : 'percent')} />
                                </div>
                                <div>
                                    <label style={LABEL}>AMOUNT</label>
                                    <AmountInput style={{ ...INPUT, fontWeight: 700, color: '#a32f2f' }} disabled value={Item['ItemAmount']} />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="pc-form-grid" style={{ display: 'grid', gridTemplateColumns: '1fr 2fr auto', gap: 16, alignItems: 'flex-end' }}>
                        <div>
                            <label style={LABEL}>IMEI / BARCODE</label>
                            <Form.Control name="ItemIMEI" style={INPUT} value={Item['ItemIMEI']} onKeyPress={this.handleEnterImei.bind(this)} onChange={this.handleChangeUpdatedItem.bind(this, 'ItemIMEI')} />
                        </div>
                        <div>
                            <label style={LABEL}>DESCRIPTION</label>
                            <Form.Control name="ItemDesc" style={INPUT} value={Item['ItemDesc']} onChange={this.handleChangeUpdatedItem.bind(this, 'ItemDesc')} />
                        </div>
                        <Button variant="contained" style={{ height: 42, whiteSpace: 'nowrap' }} onClick={this.handleAddItem.bind(this)}>ADD ITEM</Button>
                    </div>
                </div>

                {/* Table Card */}
                <div style={{ ...CARD, marginBottom: 16 }}>
                    <Table size="small" className="pc-card-table">
                        <TableHead>
                            <TableRow>
                                <TableCell style={COL_HEAD}>NAME</TableCell>
                                <TableCell style={COL_HEAD}>IMEI / BARCODE</TableCell>
                                <TableCell style={COL_HEAD}>RATE</TableCell>
                                <TableCell style={COL_HEAD}>DISCOUNT</TableCell>
                                <TableCell style={COL_HEAD}>AMOUNT</TableCell>
                                <TableCell style={COL_HEAD}>ACTION</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {this.state.AddedItemList.map((ItemDetails, idx) => (
                                <TableRow key={idx}>
                                    <TableCell>{ItemDetails.ItemName?.display}</TableCell>
                                    <TableCell>{ItemDetails.ItemIMEI}</TableCell>
                                    <TableCell onDoubleClick={this.handleEditItems.bind(this, idx, 'ItemRate', ItemDetails.ItemRate)} style={{ cursor: 'pointer' }}>
                                        {this.state.rateEditable === idx
                                            ? <AmountInput name="value" value={this.state.editObj.value} size="sm" onBlur={this.handleUpdateEditableItem.bind(this, 'blur')} onKeyPress={this.handleUpdateEditableItem.bind(this, 'key_press')} onChange={this.handleChangeEditableItem.bind(this)} />
                                            : '£ ' + formatAmount(ItemDetails.ItemRate)
                                        }
                                    </TableCell>
                                    <TableCell>{(ItemDetails.ItemDisc === '0' || ItemDetails.ItemDisc === 0) ? '' : (ItemDetails.ItemDisType === 'number' ? '£ ' + formatAmount(ItemDetails.ItemDisc) : '% ' + ItemDetails.ItemDisc)}</TableCell>
                                    <TableCell>£ {formatAmount(ItemDetails.ItemAmount)}</TableCell>
                                    <TableCell>
                                        <IconButton size="small" onClick={this.handleRemove.bind(this, idx, ItemDetails)}>
                                            <RemoveIcon />
                                        </IconButton>
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                        <tfoot>
                            <tr>
                                <td colSpan={4} style={{ padding: '12px 16px', fontWeight: 700, color: '#64748b', fontSize: 12, textTransform: 'uppercase' }}>Net Sale</td>
                                <td style={{ padding: '12px 16px', fontWeight: 700, color: '#1e293b' }}>£ {formatAmount(this.renderTotalAmount())}</td>
                                <td />
                            </tr>
                        </tfoot>
                    </Table>
                </div>

                {/* Footer */}
                <div style={{ ...CARD, padding: '16px 20px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <div style={{ display: 'flex', gap: 8 }}>
                        <Button variant="outlined" onClick={this.handleExit.bind(this)}>EXIT</Button>
                        <Button variant="contained" onClick={this.handleSaveInvoice.bind(this)}>
                            {this.state.isEdit ? 'UPDATE' : 'SAVE'}
                        </Button>
                    </div>
                    {this.state.isEdit && (
                        <ReactToPrint
                            trigger={() => <Button variant="contained" color="tertiary" startIcon={<PrintIcon />}>PRINT INVOICE</Button>}
                            content={() => this.printAFSale}
                        />
                    )}
                </div>

                <SaleDeviceAF ref={el => (this.printAFSale = el)} jobData={{
                    FOR: 'Devices',
                    INV_NUMBER: this.state.PC_WHS_INV,
                    ITEM_LIST: this.state.AddedItemList,
                    SALE_TO: this.state.SALE_TO_TYPE === 'Customer' ? this.state.Customer : this.state.SaleToShop?.label,
                    GRAND_TOTAL: this.renderTotalAmount()
                }} />
            </Container>
        );
    }
}
